import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Panel from 'HTKit/Elements/Panel/Panel';
import { prevented } from 'src/utils/event';
import useOutsideClick from 'src/hooks/useOutsideClick';
import { ItemWithCaret } from 'src/components/HTKit/Elements/Menu';
import styles from './styles.scss';

/**
  TotalPriceCaret
*/
export const TotalPriceCaret = ({ price, isOpen, toggle }) => {
  const toggleOpen = prevented(toggle);
  return (
    <ItemWithCaret
      text={price}
      isOpen={isOpen}
      onClick={toggleOpen}
      containerStyles={styles.totalPriceCaretContainer}
      textStyles={styles.skuPrice}
      iconStyles={styles.caret}
      iconOpenStyles={styles.caretOpen}
    />
  );
};

TotalPriceCaret.defaultProps = {
  price: '$0',
  toggle: () => {},
};

TotalPriceCaret.propTypes = {
  price: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

/**
  BreakdownDropdown
*/
export const BreakdownDropdown = ({ isOpen, breakdown, toggle }) => {
  const tableRef = useRef(null);

  const togglePanelCB = () => {
    if (isOpen) toggle();
  };

  useOutsideClick(tableRef, togglePanelCB, [isOpen]);

  const containerStyles = cn(styles.breakdownContainer, {
    [styles.show]: isOpen,
  });
  const priceStyles = cn('p2', styles.itemPrice);

  return (
    <Panel className={containerStyles} noMargins>
      {breakdown && breakdown.length && (
        <table ref={tableRef} className={styles.table}>
          {breakdown.map((item, i) => {
            return (
              <tr className={styles.row} key={i}>
                <td className={styles.data}>
                  <p className="p2 n700">{item.label}</p>
                </td>
                <td className={styles.data}>
                  <p className={priceStyles}>{item.price}</p>
                </td>
              </tr>
            );
          })}
        </table>
      )}
    </Panel>
  );
};

BreakdownDropdown.defaultProps = {
  breakdown: [],
  toggle: () => {},
};

BreakdownDropdown.propTypes = {
  isOpen: PropTypes.bool,
  breakdown: PropTypes.array,
  toggle: PropTypes.func,
};

/**
  ProgressBar
*/
export const ProgressBar = ({ percentage }) => {
  const barWidthStyle = { width: percentage };
  return (
    <div className={styles.progressBarWrapper}>
      <div className={styles.bar} style={barWidthStyle} />
    </div>
  );
};

ProgressBar.defaultProps = {
  percentage: '0%',
};

ProgressBar.propTypes = {
  percentage: PropTypes.string,
};
